import * as React from 'react';

export const FilterFillIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='13'
    height='14'
    viewBox='0 0 13 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <g clipPath='url(#clip0_269_2889)'>
      <path
        d='M5.41663 8.08333L2.16663 3.20833V2.125H10.8333V3.20833L7.58329 8.08333V11.3333L5.41663 12.4167V8.08333Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_269_2889'>
        <rect
          width='13'
          height='13'
          fill='white'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
);
